<template>
  <div>
    <div class="ui form" ref="form">
      <h4 class="ui dividing header">
        <i class="student icon"></i> {{ $t("student movement integration") }}
      </h4>
      <div class="field">
        <label for="">{{ $t("distribution policy") }}</label>
        <div class="ui selection dropdown" ref="policy_dropdown">
          <input type="hidden" name="policy" />
          <i class="dropdown icon"></i>
          <div class="default text">{{ $t("select one") }}</div>
          <div class="menu">
            <div class="item" data-value="none">
              {{ $t("do not distribute on student movements") }}
            </div>
            <div class="item" data-value="oldest">
              {{ $t("oldest movements first") }}
            </div>
            <div class="item" data-value="manual">
              {{ $t("manually select movents") }}
            </div>
          </div>
        </div>
      </div>
      <div class="ui icon labeled blue button" @click="save">
        <i class="save icon"></i> {{ $t("save") }}
      </div>
      <div class="ui error message"></div>
    </div>
  </div>
</template>

<script>
import { local_api, stringify } from "@/utils";

export default {
  name: "Settings",
  components: {},
  props: {},
  data() {
    return {
      setup: {
        student_movement_policy: "",
      },
      form: undefined,
    };
  },
  methods: {
    save() {
      let vm = this;
      if (vm.form) {
        let isValid = vm.form.form("validate form");
        if (isValid) {
          local_api(vm, "post", "/account_transaction/do-save-configuration", {
            s: JSON.stringify(vm.setup),
          })
            .then(() => {
              vm.$emit("close");
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            });
        }
      }
    },
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/account_transaction/do-get-configuration")
      .then((conf) => {
        if (conf) {
          vm.setup = conf;

          if (vm.setup.student_movement_policy) {
            console.log("set selected", vm.setup.student_movement_policy);
            window
              .jQuery(vm.$refs.policy_dropdown)
              .dropdown("set selected", vm.setup.student_movement_policy);
          }
        }
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.policy_dropdown).dropdown({
      onChange(value) {
        vm.setup.student_movement_policy = value;
      },
    });

    vm.form = window.jQuery(vm.$refs.form).form({
      fields: {
        policy: ["empty"],
      },
    });
  },
};
</script>
